import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { SiteLayout } from './components/site/SiteLayout.jsx';
import { PageLoader } from './components/common/Skeletons.jsx';
import Home from './pages/Home.jsx';
import Shop from './pages/Shop.jsx';
import Product from './pages/Product.jsx';
import OrderConfirmation from './pages/OrderConfirmation.jsx';
import TrackOrder from './pages/TrackOrder.jsx';
import NotFound from './pages/NotFound.jsx';

// The admin panel is a separate concern and a separate bundle: storefront
// visitors never download it.
const AdminApp = lazy(() => import('./admin/AdminApp.jsx'));

export default function App() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:slug" element={<Product />} />
        <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
        <Route path="/track" element={<TrackOrder />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<PageLoader label="Connix Admin" />}>
            <AdminApp />
          </Suspense>
        }
      />
    </Routes>
  );
}
